// apps/client/src/components/AIChat/SuggestedQuestions.tsx

import React from 'react';
import { Sparkles } from 'lucide-react';

interface SuggestedQuestionsProps {
  onSelect: (question: string) => void;
  disabled?: boolean;
}

// Default suggested questions for brokers
const DEFAULT_QUESTIONS = [
  "What's my commission this month?",
  "Which lender pays me the most?",
  "Show me my trail forecast",
  "How many clawbacks this year?",
  "What's my average upfront rate?",
  "Compare my performance to last month",
];

/**
 * Display suggested questions as clickable chips
 * Helps users discover what they can ask the AI
 */
export function SuggestedQuestions({ onSelect, disabled = false }: SuggestedQuestionsProps) {
  return (
    <div className="border-t border-gray-700 bg-gray-800/50 backdrop-blur-sm p-3">
      <div className="flex items-center gap-1 mb-2">
        <Sparkles className="w-3 h-3 text-orange-400" />
        <p className="text-xs font-medium text-gray-300">Suggested questions</p>
      </div>

      <div className="flex flex-wrap gap-2">
        {DEFAULT_QUESTIONS.slice(0, 4).map((question) => (
          <button
            key={question}
            onClick={() => onSelect(question)}
            disabled={disabled}
            className={`
              text-xs bg-gray-700/50 border border-gray-600 text-gray-200
              rounded-full px-3 py-1.5 transition-all duration-200
              ${disabled
                ? 'opacity-50 cursor-not-allowed'
                : 'hover:bg-gradient-to-r hover:from-orange-500/20 hover:to-red-500/20 hover:border-orange-500'
              }
            `}
          >
            {question}
          </button>
        ))}
      </div>
    </div>
  );
}
